import { CREATE_NATURE_MAGAZINE_START } from "../../types";

export const create_nature_magazine = (payload) => ({
    type: CREATE_NATURE_MAGAZINE_START,
    payload,
});
